<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_learning_video") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleAr')"
            v-model.trim="data.title_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleEn')"
            v-model.trim="data.title_en"
            required
          />
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.video_url')"
            v-model.trim="data.video_url"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateLearningVideo",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        title_ar: null,
        title_en: null,
        video_url: null,
      },
    };
  },

  methods: {
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("title[ar]", this.data.title_ar || "");
      REQUEST_DATA.append("title[en]", this.data.title_en || "");
      REQUEST_DATA.append("video_url", this.data.video_url || "");

      try {
        await this.$axios({
          method: "POST",
          url: "learningVideos",
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/learning-videos/all" });
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to add learning video"
        );
      } finally {
        this.isWaitingRequest = false;
      }
    },
  },
};
</script>
